<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="purchaseInventoryForm commonFormStyles">
            <HeaderNav
                header-title="入库单"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList" :class="{'formList_Readonly' : isReadonly}">
                <li>
                    <van-field
                        disabled
                        label="采购入库单号"
                        placeholder="自动生成"
                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                        v-model="formData.InstockNumber"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="来源单据单号"
                        placeholder="选择来源单"
                        :disabled="type != 'new'"
                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                        v-model="formData.SourceNumber"
                        @click="selectSource"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="需求部门"
                        placeholder="自动生成"
                        :left-icon="require('@/assets/images/icons/icon_29@2x.png')"
                        v-model="formData.ApplyDeptName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="物料代码"
                        placeholder="选择物料"
                        :disabled="type != 'new'"
                        :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                        v-model="formData.MaterialCode"
                        @click="selectMaterial"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="物料短描述"
                        placeholder="选择物料"
                        :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                        v-model="formData.MaterialShortName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="仓库编号"
                        placeholder="选择仓库"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                        v-model="formData.StockCode"
                        @click="selectWarehouse"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="仓库名称"
                        placeholder="选择仓库"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.StockName"
                        @click="selectWarehouse"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="库位编码"
                        placeholder="选择库位"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_46@2x.png')"
                        v-model="formData.GridCode"
                        @click="selectGrid"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        readonly
                        label="库位名称"
                        placeholder="选择库位"
                        class="fieldStyle"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_5@2x.png')"
                        v-model="formData.GridName"
                        @click="selectGrid"
                    >
                        <template v-slot:label>
                            <span>库位名称</span>
                            <van-button type="danger" size="mini" @click.stop="newLocation">
                                新建库位
                            </van-button>
                        </template>
                    </van-field>
                </li>
                <li>
                    <van-field
                        label="数量"
                        :disabled="isReadonly || type != 'new'"
                        :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                        v-model="formData.VolumeInstock"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="单位"
                        placeholder="选择物料"
                        :left-icon="require('@/assets/images/icons/icon_24@2x.png')"
                        v-model="formData.Unit"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="状态"
                        :left-icon="require('@/assets/images/icons/icon_13@2x.png')"
                        v-model="status"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="制单时间"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.CreationTime"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="入库人"
                        :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                        v-model="formData.InstockUserName"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        disabled
                        label="入库时间"
                        :left-icon="require('@/assets/images/icons/icon_7@2x.png')"
                        v-model="formData.InstockTime"
                    ></van-field>
                </li>
                <li>
                    <van-field
                        label="备注"
                        type="textarea"
                        :rows="2"
                        :disabled="isReadonly"
                        :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                        v-model="formData.Remarks"
                    ></van-field>
                </li>
            </ul>
            <footer class="currencyFooterStyle" v-if="!isReadonly">
                <button class="confirm" @click="formOperation('save')">
                    保存
                </button>
                <button class="confirm" @click="formOperation('submit')">
                    确认
                </button>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
import { HeaderNav } from '@/components/';
export default {
    // 库位表单
    name: 'purchase-inventory-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/purchaseInventory') {
            this.$store.commit('noKeepAlive', 'purchase-inventory-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            isReadonly: false,
            formData: {
                Id: '',
                StockId: '',
                StockCode: '',
                StockName: '',
                GridId: '',
                GridCode: '',
                GridName: '',
                ApplyDeptId: '',
                ApplyDeptName: '',
                StoremanId: '',
                StoremanName: '',
                Remarks: '',
                Status: 0,
                SourceId: '',
                SourceNumber: '',
                ContractNo: '',
                ContractNumber: '',
                SupplierId: '',
                SupplierName: '',
                MaterialCode: '',
                MaterialName: '',
                MaterialShortName: '',
                MaterialCategory: 0,
                Unit: '',
                VolumeInstock: 0,
                UnitPrice: 0,
                TaxRate: 0,
            },
            status: '',
            type: '',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.source) {
            this.formData.SourceId = this.$route.params.source[0].id;
            this.formData.SourceNumber = this.$route.params.source[0].contract_no;
            this.formData.ContractNo = this.$route.params.source[0].contract_no;
            this.formData.ContractNumber = this.$route.params.source[0].contract_number;
            this.formData.SupplierId = this.$route.params.source[0].supplier_id;
            this.formData.SupplierName = this.$route.params.source[0].supplier_name;

            this.formData.MaterialCode = '';
            this.formData.MaterialName = '';
            this.formData.MaterialShortName = '';
            this.formData.MaterialCategory = '';
            this.formData.Unit = '';
            this.formData.UnitPrice = '';
            this.formData.TaxRate = '';

            this.resetStockAndGridFields();
        }
        if (this.$route.params.material) {
            this.formData.MaterialCode = this.$route.params.material[0].material_code;
            this.formData.MaterialName = this.$route.params.material[0].material_name;
            this.formData.MaterialShortName = this.$route.params.material[0].material_short_name;
            this.formData.MaterialCategory = this.$route.params.material[0].material_category;
            this.formData.Unit = this.$route.params.material[0].unit;
            this.formData.UnitPrice = this.$route.params.material[0].unit_price;
            this.formData.TaxRate = this.$route.params.material[0].tax_rate;

            this.resetStockAndGridFields();
        }
        if (this.$route.params.warehouseData) {
            this.formData.StockCode = this.$route.params.warehouseData[0].StockCode;
            this.formData.StockId = this.$route.params.warehouseData[0].StockId;
            this.formData.StockName = this.$route.params.warehouseData[0].StockName;

            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
            this.formData.StockGridMaterialId = '';
            this.formData.StoremanId = '';
            this.formData.StoremanName = '';
        }
        if (this.$route.params.gridData) {
            this.formData.GridId = this.$route.params.gridData[0].GridId;
            this.formData.GridCode = this.$route.params.gridData[0].GridCode;
            this.formData.GridName = this.$route.params.gridData[0].GridName;
            this.formData.StockGridMaterialId = this.$route.params.gridData[0].StockGridMaterialId;
            this.formData.StoremanId = this.$route.params.gridData[0].StoremanId;
            this.formData.StoremanName = this.$route.params.gridData[0].StoremanName;
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'purchaseInventory' });
        },

        // 重置仓库和库位相关字段
        resetStockAndGridFields() {
            this.formData.StockCode = '';
            this.formData.StockId = '';
            this.formData.StockName = '';

            this.formData.GridId = '';
            this.formData.GridCode = '';
            this.formData.GridName = '';
            this.formData.StockGridMaterialId = '';
            this.formData.StoremanId = '';
            this.formData.StoremanName = '';
        },

        async initpage() {
            this.type = this.$route.params.type;
            if (this.type !== 'new') {
                this.formData = await this.getformDataRequrst(this.$route.params.data.id);
            } else {
                this.formData.CreationTime = currencyFun.timeFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                this.formData.InstockUserName = this.$takeTokenParameters('Name');
            }
            if (this.type === 'see') {
                this.isReadonly = true;
            }
            this.status = this.formData.Status ? '已入库' : '未入库';
        },

        // 选择来源单
        selectSource() {
            if (this.isReadonly) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择来源单',
                    sourcePath: 'purchaseInventoryForm',
                    listCode: 'instock_material_choose_source',
                    callbackDataKey: 'source',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '合同编号',
                        code: 'contract_no',
                        isTitle: true,
                    }, {
                        name: '合同名称',
                        code: 'contract_name',
                        icon: 'icon_1@2x',
                    }, {
                        name: '签约日期',
                        code: 'signing_date',
                        icon: 'icon_7@2x',
                    }, {
                        name: '供应商',
                        code: 'supplier_name',
                        icon: 'icon_4@2x',
                    }],
                },
            });
        },

        // 选择物料
        selectMaterial() {
            if ((this.formData.SourceId || '') === '') {
                this.$toast.fail('请先选择来源单！');
                return;
            }
            if (this.isReadonly) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择物料',
                    sourcePath: 'purchaseInventoryForm',
                    listCode: 'instock_material_choose_material',
                    requestUrl: `/basicplatform/tabledata?source_id=${this.formData.SourceId}`,
                    callbackDataKey: 'material',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料编码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '物料名称',
                        code: 'material_name',
                        icon: 'icon_1@2x',
                    }, {
                        name: '单位',
                        code: 'unit',
                        icon: 'icon_2@2x',
                    }, {
                        name: '供应商',
                        code: 'supplier_name',
                        icon: 'icon_4@2x',
                    }],
                },
            });
        },

        // 选择仓库
        selectWarehouse() {
            if ((this.formData.MaterialCode || '') === '') {
                this.$toast.fail('请先选择物料！');
                return;
            }
            if (this.isReadonly) { return; }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择仓库',
                    sourcePath: 'purchaseInventoryForm',
                    callbackDataKey: 'warehouseData',
                    requestUrl: `/procurement/stock_grid/stock_by_materialcode?materialCode=${this.formData.MaterialCode}&isFilter=0`,
                    relationKey: 'StockId',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    pageSize: 9999,
                    requestType: 'get',
                    headerList: [{
                        name: '仓库编号',
                        code: 'StockCode',
                        isTitle: true,
                    }, {
                        name: '仓库名称',
                        code: 'StockName',
                        icon: 'icon_44@2x',
                    }, {
                        name: '需求部门',
                        code: 'ApplyDeptName',
                        icon: 'icon_29@2x',
                    }, {
                        name: '仓库保管员',
                        code: 'StoremanName',
                        icon: 'icon_8@2x',
                    }],
                },
            });
        },

        // 选择库位
        selectGrid() {
            if (this.isReadonly) { return; }
            if ((this.formData.StockId || '') === '') {
                this.$toast.fail('请先选择仓库！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectTable',
                params: {
                    sourcePath: 'purchaseInventoryForm',
                    requestUrl: `/procurement/stock_grid/grid_by_materialcode_stock?materialCode=${this.formData.MaterialCode}&stockId=${this.formData.StockId}`,
                    callbackDataKey: 'gridData',
                    relationKey: 'GridId',
                    pageSize: 9999,
                    requestType: 'get',
                    headerList: [{
                        name: '库位编号',
                        code: 'GridCode',
                    }, {
                        name: '库位名称',
                        code: 'GridName',
                    }],
                },
            });
        },

        async formOperation(type) {
            if (type === 'save') {
                this.formData.Status = 0;
            } else {
                this.formData.Status = 1;
            }
            let msgText = '';
            if ((this.formData.StockId || '') === '') {
                msgText += ' 仓库 ';
            }
            if ((this.formData.GridId || '') === '') {
                msgText += ' 库位 ';
            }
            if (msgText !== '') {
                this.$toast.fail(`请选择${msgText}!`);
                return;
            }
            const res = await this.formOperationRequrst(this.formData);
            if (res) {
                this.$toast.success(`${type === 'save' ? '保存成功。' : '确认成功。'}`);
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'purchaseInventory',
                    params: {
                        saveCallback: true,
                    },
                });
            }
        },

        // 新增库位
        newLocation() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'warehouseLocationForm', params: { type: 'warehousingNew' } });
        },

        getformDataRequrst(id) {
            return this.$axios.$get(`/interfaceApi/procurement/instock_material/instock_material_single?id=${id}`);
        },

        formOperationRequrst(formData) {
            return this.$axios.$post('/interfaceApi/procurement/instock_material/instock_material_save_wz', formData);
        },
    },
};
</script>
<style lang="stylus">
.purchaseInventoryForm
    .formList
        &.formList_Readonly
            height calc(100% - 44rpx)
        .fieldStyle
            .van-cell__title
                display flex
                align-items: center
                gap 10rpx
                .van-button
                    .van-button__text
                        height 30rpx
                        line-height 30rpx
                        font-size 12rpx
</style>
